import {
  InfiniteScrollTable as SharedInfiniteScrollTable,
  InfiniteScrollTableProps as SharedInfiniteScrollTableProps,
} from "@flaminem/ui-components";

import { useT } from "src/internationalization";

export type InfiniteScrollTableProps<TData extends { id: string }> = Omit<
  SharedInfiniteScrollTableProps<TData>,
  "footer"
> & {
  footer?: Partial<
    Pick<SharedInfiniteScrollTableProps<TData>["footer"], "languageTexts" | "height">
  >;
};

export function InfiniteScrollTable<TData extends { id: string }>({
  noRowsText,
  ...props
}: InfiniteScrollTableProps<TData>) {
  const t = useT();

  return (
    <SharedInfiniteScrollTable
      {...props}
      noRowsText={noRowsText ?? t("general.table.empty")}
      footer={{
        languageTexts: {
          item: t("component.table.infinite.item"),
          items: t("component.table.infinite.items"),
        },
      }}
    />
  );
}
